export function backtotop() {
  var scrollToTopBtn = document.querySelector(".back-to-top");
  var rootElement = document.documentElement;
  var TOGGLE_RATIO = 0.8;

  if (scrollToTopBtn) {
    function handleScroll() {
      var scrollTotal = rootElement.scrollHeight - rootElement.clientHeight;
      if (rootElement.scrollTop / scrollTotal > TOGGLE_RATIO) {
        scrollToTopBtn.classList.add("show-button");
      } else {
        scrollToTopBtn.classList.remove("show-button");
      }
    }

    function scrollToTop() {
      rootElement.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
    scrollToTopBtn.addEventListener("click", scrollToTop);
    document.addEventListener("scroll", handleScroll);
  }
}
